(function () {
  var TARGET_SELECTOR = '.candy-home__pack-item, .collection-origin-product';
  var activeTimers = new WeakMap();
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getTextSignal(element) {
    return [
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.textContent
    ].filter(Boolean).join(' ').toLowerCase();
  }

  function inferEffect(element) {
    var preset = element.getAttribute('data-candy-effect');
    if (preset) return preset;

    var signal = getTextSignal(element);

    if (/monster|fanta|cola|sprite|prime|red bull|energy|drink|ital|soda|\bml\b/.test(signal)) return 'drink';
    if (/reese|chocolate|csoki|csokol|oreo|wafer|bar/.test(signal)) return 'chocolate';
    if (/takis|doritos|chips?|puffs?|snack|cheetos|tortilla/.test(signal)) return 'chips';
    if (/nerds|sour|patch|warheads|toxic|gummy|gumicukor|candy|cukor|savany/.test(signal)) return 'candy';

    return 'sparkle';
  }

  function clearContour(element) {
    var timer = activeTimers.get(element);
    if (timer) {
      window.clearTimeout(timer);
      activeTimers.delete(element);
    }

    element.classList.remove('candy-contour-active');
  }

  function triggerContour(element) {
    if (!element || reducedMotion) return;

    clearContour(element);
    element.classList.add('candy-burst-target', 'candy-contour-active');

    activeTimers.set(element, window.setTimeout(function () {
      clearContour(element);
    }, 1250));
  }

  function initTarget(element) {
    if (element.dataset.candyBurstReady === '1') return;

    element.dataset.candyBurstReady = '1';
    element.classList.add('candy-burst-target');

    if (!element.getAttribute('data-candy-effect')) {
      element.setAttribute('data-candy-effect', inferEffect(element));
    }

    element.addEventListener('focus', function () {
      triggerContour(element);
    }, { passive: true });

    element.addEventListener('pointerdown', function () {
      triggerContour(element);
    }, { passive: true });

    element.addEventListener('touchstart', function () {
      triggerContour(element);
    }, { passive: true });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(TARGET_SELECTOR).forEach(initTarget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.CandylandProductBurst = Object.assign(window.CandylandProductBurst || {}, {
    init: init,
    trigger: triggerContour,
    inferEffect: inferEffect
  });
}());
